export const MultiFamily = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 22 20'>
        <path
          d='M8.83252 12.2766V8.11477C8.83252 7.65506 8.45985 7.2824 8.00015 7.2824H4.67066C4.21095 7.2824 3.83828 7.65506 3.83828 8.11477V12.2766L12.162 12.2766V4.78603C12.162 4.51303 12.0281 4.25737 11.8038 4.10187C11.5794 3.94636 11.293 3.91077 11.0374 4.00663L7.70788 5.25519C7.383 5.37702 7.16777 5.68759 7.16777 6.03456V7.2824M4.67521 15.6292H11.3246C13.6258 15.6292 15.4912 13.7637 15.4912 11.4625V4.81315C15.4912 2.51196 13.6258 0.646484 11.3246 0.646484H4.67521C2.37402 0.646484 0.508545 2.51196 0.508545 4.81315V11.4625C0.508545 13.7637 2.37402 15.6292 4.67521 15.6292Z'
          stroke='currentcolor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
};
